import ChartBase from "./ChartBase";
export class GraphChartTable extends ChartBase {
    constructor() {
        super();
        this._init = () => {
            // chart type
            this.chartType = "DonutTableChart";
            // always call this
            this._getElements();
            // get elements
            this.chartElement = this.querySelector("sva-donut-chart");
            this.tableElement = this.querySelector("sva-table");
            // toggle
            this.toggleElement = this.wrapper.querySelector("[data-table-toggle]");
            // check hide/show
            this._updateToggleText();
            // add toggle event
            this.toggleElement.addEventListener("click", (e) => {
                e.preventDefault();
                // toggle
                if (this.hasAttribute("hide-table")) {
                    this.removeAttribute("hide-table");
                }
                else {
                    this.setAttribute("hide-table", '');
                }
                this._updateToggleText();
            });
        };
        this.updateData = (props) => {
            //set metric and question
            this._setBaseInfo(props);
            // get data and labels
            const { chartData, tableData } = props;
            // render
            window.customElements.whenDefined('sva-donut-chart').then(() => {
                this.chartElement.updateData(Object.assign(Object.assign({}, chartData), { metric: "", question: "" }));
            });
            window.customElements.whenDefined('sva-table').then(() => {
                this.tableElement.updateData(Object.assign(Object.assign({}, tableData), { metric: "", question: "" }));
            });
            // remove loading
            this.loading = false;
        };
        this._updateToggleText = () => {
            if (this.hideTable) {
                this.toggleElement.textContent = "Show table";
                this.tableElement.hide();
            }
            else {
                this.toggleElement.textContent = "Hide table";
                this.tableElement.show();
            }
        };
    }
    get hideTable() {
        return this.hasAttribute("hide-table") ? "hide" : "";
    }
    connectedCallback() {
        // html template
        this.innerHTML = `
            <div class="${this.class} dashboard-charts-item" data-wrapper>
                <div class="d-flex align-items-center mb-3">
                    <h6 class="text-uppercase font-weight-bold mb-0" data-metric></h6>
                    ${!!this.chartName ? `<div class="dashboard-charts-name">${this.chartName}</div>` : ''}
                </div>
                <p class="text-muted-light font-italic dashboard-charts-item-question" data-question></p>
                <sva-donut-chart large no-loading noquestion ignored></sva-donut-chart>
                <sva-table no-loading ignored noquestion></sva-table>
                <a href="#" class="dashboard-charts-link py-2 mt-4" data-table-toggle></a>
            </div>
        `;
        this._init();
    }
}
window.customElements.define("sva-graph-chart-table", GraphChartTable);
